const map = {
  CMS: 'https://localhost:8084/'
};

export default function hostMap(project) {
  // 生产环境或测试环境直接从环境变量里读，本地环境从 map 里面获取，方便本地开发的时候修改地址避免重启服务。
  if (process.env.NODE_ENV === 'production') return process.env[`VUE_APP_${project}_HOST`];
  return map[project];
}
